import { Injectable, inject } from '@angular/core'
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router'
import { AuthService } from './auth.service'
import { Store } from '@ngrx/store'
import { ClientActions } from '../state/client/client.actions'
import { catchError, map, of, tap } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class PicPayAuthGuard implements CanActivate {
	private authService = inject(AuthService)
	private store = inject(Store)
	private router = inject(Router)

	canActivate(route: ActivatedRouteSnapshot) {
		const externalUserId = route.queryParamMap.get('externalUserId')

		if (externalUserId) {
			return this.authService.loginWithPicPay(externalUserId).pipe(
				tap(user => {
					this.store.dispatch(ClientActions.loadClient({ id: user._id }))
					this.router.navigate([], { queryParams: {}, replaceUrl: true })
				}),
				map(() => true),
				catchError(err => {
					console.error('Erro no login PicPay:', err)
					return of(false)
				})
			)
		}

		// Se não tem externalUserId, apenas libera a rota
		return of(true)
	}
}
